// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/tok/jenkins/home/workspace/tok_website_boss/src/models/user';

export const models = {
model_1: { namespace: 'user', model: model_1 },
} as const
